export default __webpack_public_path__ + "static/hapi-logo-d1f0d51b2b70656fd58a918eeee582f9.png";